<template>
  <div class="event-categories-component">
    <div class="event-row-wrapper">
      <!-- Event category select -->
      <div class="form-field-container">
        <div
          class="checkboxes"
          :class="{ 'disabled': isCategoryDisabled }"
        >
          <div
            class="checkbox"
            :class="{ 'disabled': isCategoryDisabled }"
            @click="onCategorySelected"
            :data-action="`check-hid-${eventCategory.humanReadableId}`"
          >
            <input type="checkbox" :checked="selected" />
            <span class="form-checkbox" />
            <span>{{ eventCategory.name }}</span>
          </div>
        </div>
      </div>

      <!-- Event details toggle -->
      <div class="form-field-container">
        <!-- Show -->
        <a v-if="isCollapsed" class="view-details-toggle" @click="toggleEventDetails">
          <span v-translate>View details</span>
          <font-awesome-icon
            class="arrow"
            :icon="['fa', 'chevron-down']"
            :style="{ fontSize: '0.875rem' }"
          />
        </a>

        <!-- Hide -->
        <a v-else class="view-details-toggle" @click="toggleEventDetails">
          <span v-translate>Hide details</span>
          <font-awesome-icon
            class="arrow"
            :icon="['fa', 'chevron-up']"
            :style="{ fontSize: '0.875rem' }"
          />
        </a>
      </div>
    </div>

    <!-- Event details -->
    <div v-if="!isCollapsed" class="form-field-container event-details-container">
      <!-- Description -->
      <div class="event-description" v-html="description"></div>

      <!-- Required documentation & examples -->
      <div
        v-if="organizationDetails.eventDocumentationEnabled"
        class="event-details-documentation eligibility-list"
      >
        <p><translate>You'll need documentation showing</translate>:</p>
        <span v-html="getCategoryDocumentationText(eventCategory)"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/services/utils'

export default {
  name: 'EventCategoryComponent',
  props: {
    eventCategory: {
      type: Object,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCollapsed: true,
    }
  },
  mounted() {
    if (this.selected) {
      this.isCollapsed = false
    }
  },
  methods: {
    onCategorySelected() {
      if(this.isCategoryDisabled)
        return

      if (!this.selected) {
        this.$emit('selected', this.eventCategory)
      } else {
        this.$emit('unselected', this.eventCategory)
      }
    },
    toggleEventDetails() {
      this.isCollapsed = !this.isCollapsed
    },
    getCategoryDocumentationText(eventCategory) {
      return eventCategory.documentationDescShortHtml
    },
  },
  computed: {
    ...mapState(['user','organizationDetails', 'organizationCssVars']),
    eventCardClasses() {
      return {
        'toggle-close': this.isCollapsed,
      }
    },
    description() {
      const desc = this.eventCategory.descriptionHtml
      const alt_desc = this.eventCategory.alternateDescriptionHtml

      return alt_desc || desc
    },
    isCategoryDisabled() {
      const userZipCode = this.user?.zipCode
      const eventCategory = this.eventCategory

      // If the user has a zip code and the category is a natural disaster, then disable
      // the event if the user's zip code is not in the valid zip codes list.
      if(userZipCode && eventCategory.isNaturalDisaster && !eventCategory.validZipCodes.includes(parseInt(userZipCode)))
        return true

      return false
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/responsive';

.event-categories-component {
  .form-field {
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .checkbox {
    span.form-checkbox + span {
      font-family: 'SFPro-Regular';
      font-weight: bold;
      font-size: 1.125rem;
      line-height: 1.5rem;
    }

    &.disabled {
      span.form-checkbox + span {
        color: gray;
      }
    }
  }

  .view-details-toggle {
    color: #0067b9 !important;
    text-decoration: none;
    font-family: 'SFPro-Regular';
    font-size: 0.875rem;
    font-weight: bold;
    line-height: 1rem;
    margin-left: 2.5rem;
    padding-left: 2px;

    &:hover {
      text-decoration: none;
    }

    span {
      margin-right: 8px;
    }
  }

  .event-details-container {
    border-top: 1px solid #dfdfe0;
    padding-top: 1.5rem;
    margin-top: 1rem;
  }

  .event-description {
    margin-bottom: 1.5rem;
  }
}

@include tablet-and-up-screen {
  .event-row-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .form-field-container {
    margin-top: 0;
  }
}
</style>
